import "./Moneyconvert.css";
import axios from "axios";
import { CurrencyData } from "./currencys";
import { Button, ButtonToggle, Input, InputGroup } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Link } from "react-router-dom";

const MoneyConvertwidgets = () => {
  const [from, setFrom] = useState("USD");
  const [to, setTo] = useState("USD");
  const [ratio, setRestio] = useState(1);
  const [money, setMoney] = useState(1);
  const CurrencyNames = Object.values(CurrencyData);
  const { t } = useTranslation();
  const options = {
    method: "GET",
    url: `${process.env.REACT_APP_CURRENCY_API_ENDPOINT}`,
    params: { from: `${from}`, to: `${to}`, q: "1000" },
    headers: {
      "X-RapidAPI-Key": `${process.env.REACT_APP_CURRENCY_API_KEY}`,
      "X-RapidAPI-Host": `${process.env.REACT_APP_CURRENCY_API_HOST}`,
    },
  };

  const currencyList = async () => {
    try {
      const res = await axios.request(options);
      setRestio(() => res.data);
    } catch (err) {}
  };

  const handelFromChange = (e) => {
    setFrom(() => e.target.value);
  };

  const handelToChange = (e) => {
    setTo(() => e.target.value);
  };

  const handelFromMoneyChange = (e) => {
    setMoney(e.target.value);
  };

  const handelConvert = () => {
    currencyList();
  };

  return (
    <>
      {" "}

      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("Currency Convert")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="formContainer">
        <div>
          <label>{t("From")}</label>
          <Input onChange={handelFromMoneyChange}></Input>
          <InputGroup>
            <Input
              type="select"
              id="fieldType"
              name="fieldType"
              onChange={handelFromChange}
              placeholder="1"
            >
              {CurrencyNames.map((ele, i) => (
                <option value={ele.code}>{ele.name} </option>
              ))}
            </Input>
          </InputGroup>
        </div>

        <div>
          <label>{t("To")}</label>

          <Input value={money * ratio}></Input>
          <InputGroup>
            <Input
              type="select"
              id="fieldType"
              name="fieldType"
              onChange={handelToChange}
              placeholder="1"
            >
              {CurrencyNames.map((ele, i) => (
                <option value={ele.code}>{ele.name} </option>
              ))}
            </Input>
            <Button onClick={handelConvert} color="success">
              {t("convert money")}
            </Button>
          </InputGroup>
        </div>
      </div>
    </>
  );
};

export default MoneyConvertwidgets;
